module.exports = __webpack_public_path__ + "static/media/node-hosting.3e77e1cd.avif";